module.exports = __webpack_public_path__ + "img/code.26f5b488.svg";